import React, { useEffect, useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import {
  isInquiryProcessAlias,
  isNegotiationProcessAlias,
  OFFER,
} from '../../transactions/transaction';
import { isFactoryProductListing } from '../../util/factoryListing';
import { getFactoryAssignedAgent } from '../../util/api';

import { Heading, Modal } from '../../components';
import UserCard from './UserCard/UserCard';
import InquiryForm from './InquiryForm/InquiryForm';

import css from './ListingPage.module.css';
import detailsCss from './SectionProductDetails.module.css';

const CONTACT_USER_LINK = 'inquiryModalContactUserLink';

const SectionAuthorMaybe = props => {
  const {
    title,
    listing,
    authorDisplayName,
    onContactUser,
    isInquiryModalOpen,
    onCloseInquiryModal,
    sendInquiryError,
    sendInquiryInProgress,
    onSubmitInquiry,
    currentUser,
    onManageDisableScrolling,
  } = props;

  const publicData = listing?.attributes?.publicData || {};
  const transactionProcessAlias = publicData.transactionProcessAlias || '';
  const unitType = publicData.unitType || '';
  const isInquiryProcess = isInquiryProcessAlias(transactionProcessAlias);
  const isNegotiationProcess = isNegotiationProcessAlias(transactionProcessAlias);
  const isFactoryProduct = isFactoryProductListing(publicData);
  // Buyers never contact factories directly — source via agents in the order panel.
  const showContact =
    !isFactoryProduct && !(isInquiryProcess || (isNegotiationProcess && unitType === OFFER));

  const publicDataAgentName = publicData.agentName || null;
  const factoryUserId = listing?.author?.id?.uuid || null;
  const [agentName, setAgentName] = useState(publicDataAgentName);

  useEffect(() => {
    setAgentName(publicDataAgentName);
  }, [publicDataAgentName]);

  useEffect(() => {
    if (!isFactoryProduct || publicDataAgentName || !factoryUserId) return undefined;
    let cancelled = false;
    getFactoryAssignedAgent(factoryUserId)
      .then(data => {
        if (cancelled) return;
        const name = data?.assignment?.agentName || data?.assignment?.agentEmail || null;
        if (name) setAgentName(name);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [isFactoryProduct, publicDataAgentName, factoryUserId]);

  if (!listing?.author) {
    return null;
  }

  return (
    <section id="author" className={css.sectionAuthor}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage
          id={
            isFactoryProduct ? 'ListingPage.aboutSourcingTitle' : 'ListingPage.aboutProviderTitle'
          }
        />
      </Heading>
      {isFactoryProduct ? (
        <>
          <p className={css.authorSourcingNote}>
            <FormattedMessage id="ListingPage.aboutSourcingNote" />
          </p>
          <div className={detailsCss.fieldCard}>
            <span className={detailsCss.fieldLabel}>
              <FormattedMessage id="ListingPage.assignedAgentLabel" />
            </span>
            <span className={detailsCss.fieldValue}>
              {agentName || <FormattedMessage id="ListingPage.assignedAgentPending" />}
            </span>
          </div>
        </>
      ) : (
        <UserCard
          user={listing.author}
          currentUser={currentUser}
          onContactUser={onContactUser}
          showContact={showContact}
          contactLinkId={CONTACT_USER_LINK}
        />
      )}
      <Modal
        id="ListingPage.inquiry"
        contentClassName={css.inquiryModalContent}
        isOpen={isInquiryModalOpen}
        onClose={onCloseInquiryModal}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
        focusElementId={CONTACT_USER_LINK}
      >
        <InquiryForm
          className={css.inquiryForm}
          submitButtonWrapperClassName={css.inquirySubmitButtonWrapper}
          listingTitle={title}
          authorDisplayName={authorDisplayName}
          sendInquiryError={sendInquiryError}
          onSubmit={onSubmitInquiry}
          inProgress={sendInquiryInProgress}
        />
      </Modal>
    </section>
  );
};

export default SectionAuthorMaybe;
